import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export const formatToInternational = (phone: string) =>
  phoneUtil.format(phoneUtil.parseAndKeepRawInput(phone), PhoneNumberFormat.INTERNATIONAL);
